<script lang="ts">
    import { Select } from 'bits-ui';

    let classes = '';
    export { classes as class };

    export let selected: any = { value: 6, label: '6' };
    export let options: any[];
</script>

<Select.Root bind:selected items={options} {...$$restProps} preventScroll={false}>
    <Select.Trigger
        class="px-4 2xl:px-4 min-h-10 flex items-center justify-between gap-2 2xl:gap-3 w-full  sm:w-20 {classes}"
    >
        <Select.Value />
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="7" viewBox="0 0 11 7" fill="none">
            <path
                class="fill-primary"
                d="M5.49999 -6.5587e-08L11 0L5.49999 7L8.34742e-08 -1.31174e-07L5.49999 -6.5587e-08Z"
            />
        </svg>
    </Select.Trigger>

    <Select.Content class="max-h-56 z-50 overflow-y-auto scrollbar-white">
        <Select.Label />
        {#each Object.values(options.length > 0 ? options : Array.from({ length: 24 }, (_, i) => i + 1)) as option}
            <Select.Item
                class="px-5 py-2 bg-white select-body hover:bg-neutral-50 select-none"
                value={option}
                label={option}
            >
                {option}
                <Select.ItemIndicator />
            </Select.Item>
        {/each}
        <Select.Arrow />
    </Select.Content>
</Select.Root>
